import { difference } from "lodash"

/**
 * Computes directional differences between two lists of values.
 * Comparison semantics follow lodash `difference` (value equality for primitives,
 * reference equality for objects).
 */
export function computeListDiff<T>(
  prev: T[],
  next: T[],
): { added: T[], removed: T[] } {
  return {
    added: difference(next, prev),
    removed: difference(prev, next),
  }
}
